import * as React from 'react'
import { connect } from 'react-redux'
import { Config } from '@chegg-wt/core/config'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { DashboardUpsellCopy } from '@chegg-wt/core/types/features'
import { Dispatch } from 'redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import TermsAndConditionsLink from '../TermsAndConditionsLink'
import { GP_CTA, GP_UPSELL_ITEM, GP_UPSELL, TC_LINK } from './utils/testIds'

import {
  H2,
  PlagiarismContainer,
  CTAButton,
  PlagiarizedPaperImage,
  GPContentWrapper,
  GPFeatureWrapper,
  TermsWrapper,
  FeatureListContainer,
} from './styles'
import { FeaturePanelDispatchProps } from './types'
import { FeatureItem } from './common'

interface GPPanelProps extends FeaturePanelDispatchProps {
  upsellCopy: DashboardUpsellCopy
  onUserClick: () => void
}

const GPPanel: React.FC<GPPanelProps> = ({ upsellCopy, onUserClick }) => {
  const { FEATURE_LIST, CTA_COPY, UPSELL_HEADING, IMAGE_ALT_TEXT } = upsellCopy.plagiarism
  const handleClick = () => {
    onUserClick()
  }
  const features = FEATURE_LIST.map((text, index) => {
    return (
      <FeatureItem
        GP
        key={text}
        featureText={text}
        testId={`${GP_UPSELL_ITEM}_${index}`}
      />
    )
  })
  return (
    <PlagiarismContainer data-test={GP_UPSELL}>
      <H2>{UPSELL_HEADING}</H2>
      <GPContentWrapper>
        <PlagiarizedPaperImage
          src={publicAssetUrl('plagiarism-paper.svg')}
          alt={IMAGE_ALT_TEXT}
        />
        <GPFeatureWrapper>
          <FeatureListContainer>{features}</FeatureListContainer>
          <CTAButton
            forwardedAs="a"
            href={Config.grammarAndPlagiarismUrl}
            data-test={GP_CTA}
            aria-label={CTA_COPY}
            onClick={handleClick}
          >
            {CTA_COPY}
          </CTAButton>
          <TermsWrapper>
            <TermsAndConditionsLink
              href={Config.trialTermsAndConditionsUrl}
              testId={TC_LINK}
            />
          </TermsWrapper>
        </GPFeatureWrapper>
      </GPContentWrapper>
    </PlagiarismContainer>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClick: () => dispatch(userClick({ origin: origins.dashboardClickGPCTA })),
})

export default connect<{}, FeaturePanelDispatchProps>(null, mapDispatchToProps)(GPPanel)
